import { lazy, Suspense } from 'react'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { Loader } from '@/shared/ui/loader'
import { ISSUANCE_TABS } from '@/pages/issuance/model/tabs'

const IssuancePage = lazy(() => import('@/pages/issuance/ui/index'))

const issuanceSearchSchema = z.object({
  tab: z.enum(ISSUANCE_TABS).optional(),
})

export const Route = createFileRoute('/_protected/warehouse/issuance')({
  validateSearch: issuanceSearchSchema,
  // Keep the tab in the URL so a reload lands on the same list.
  beforeLoad: ({ search }) => {
    if (!search.tab) {
      throw redirect({
        to: '/warehouse/issuance',
        search: { tab: ISSUANCE_TABS[0] },
      })
    }
  },
  component: () => (
    <Suspense fallback={<Loader />}>
      <IssuancePage />
    </Suspense>
  ),
})
